import type { WidgetMessage } from '@/api/types';

/**
 * Whether a turn was written from the visitor's side of the conversation.
 *
 * `authorKind` is the API's enum as a bare string; compared tolerantly so
 * casing cannot break the layout or the read receipts that depend on it.
 */
export const isOwnMessage = (message: WidgetMessage): boolean => message.authorKind.toLowerCase() === 'contact';
